<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__dept" style="position: relative;">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-button v-if="$hasPermission('sys:dept:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
      </el-form>
      <el-button v-if="$hasPermission('sys:dept:oneClickSwitchable')" @click="openPay()" type="primary" plain style="position: absolute;right: 0;top: 0;">一键切三方支付</el-button>
      <el-table v-loading="dataListLoading" :data="dataList" row-key="id" border style="width: 100%;">
        <el-table-column prop="name" :label="$t('dept.name')" header-align="center" min-width="150"></el-table-column>
        <el-table-column prop="parentName" :label="$t('dept.parentName')" header-align="center" align="center"></el-table-column>
        <el-table-column prop="sort" :label="$t('dept.sort')" header-align="center" align="center" width="80"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:dept:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:dept:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
    <el-dialog :visible.sync="payVisible" @close="qx()">
      <div class="pay">
        <el-form :inline="true" :model="dataForm1" ref="dataForm1" @keyup.enter.native="dataFormSubmitHandle()">
          <el-form-item label="支付渠道统一切换到" prop="payChannelId" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
            <el-select class="sandh" v-model="dataForm1.payChannelId" placeholder="请选择">
            <el-option
              v-for="(item,index) in channelList"
              :key="index"
              :label="item.label"
             :value="item.value">
            </el-option>
          </el-select>
          </el-form-item>
        </el-form>
        <div class="warning">
          <div class="warn_icon">
            <img src="../../../assets/img/waring.svg"><img src="../../../assets/img/waring.svg"><img src="../../../assets/img/waring.svg">
          </div>
          <div class="text">点击确认后，所有资方的支付渠道将统一变为所选项，请确认无误后操作。</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="qx()">取 消</el-button>
        <el-button :disabled="isDisabled" v-loading="isDisabled" type="primary" @click="dataFormSubmitHandle">确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './dept-add-or-update'
import debounce from 'lodash/debounce'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      dataForm1:{
        payChannelId:''
      },
      channelList:[],
      payVisible:false,
      isDisabled:false,
      mixinViewModuleOptions: {
        getDataListURL: '/sys/dept/list',
        deleteURL: '/sys/dept'
      }
    }
  },
  components: {
    AddOrUpdate
  },
  methods: {
    openPay(){
      this.payVisible = true
      this.$http.get(`/sys/dict/data/list?dataType=pay_channel`).then(r=>{
        this.channelList = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
      })
    },
    qx(){
      this.payVisible = false;
      this.dataForm1 = {
        payChannelId:''
      }
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm1'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.isDisabled = true
        this.$http.get(`/sys/dept/oneClickSwitchable/${this.dataForm1.payChannelId}`).then(({ data: res })=>{
          this.isDisabled = false
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.$message({
            message: this.$t("prompt.success"),
            type: "success",
            duration: 500,
            onClose: () => {
              this.payVisible = false;
              this.dataForm1 = {
                payChannelId:''
              }
              },
          });
          
      })
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style scoped lang="scss">
.pay{
  margin: 50px;
}
  .warning{
    display: flex;
    .warn_icon{
      display: flex;
      flex-wrap: nowrap;
    }
    img{
      width: 16px;
      height: 16px;
      margin-right: 2px;
    }
    .text{
      margin-left: 20px;
    }
  }
</style>
